var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('shop-order-detail',{attrs:{"buy_items":_vm.scheduleInfo.shop.items,"order_info":_vm.scheduleInfo.shop}})}
var staticRenderFns = []

export { render, staticRenderFns }